/**
 * Loading skeleton for Carrier Settings grid
 * Shows placeholder cards in responsive grid layout
 */
export function CarrierSettingsLoading() {
  return (
    <div className='grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 lg:grid-cols-3 sm:p-6'>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div
          key={i}
          className='rounded-xl border border-sd-border bg-sd-card shadow-sm p-5'
        >
          <div className='animate-pulse space-y-4'>
            {/* Carrier Logo/Icon */}
            <div className='flex items-center gap-3'>
              <div className='h-12 w-12 rounded-lg bg-sd-muted shrink-0'></div>
              <div className='flex-1 space-y-2'>
                <div className='h-4 bg-sd-muted rounded w-24'></div>
                <div className='h-3 bg-sd-muted rounded w-16'></div>
              </div>
            </div>
            
            {/* Settings/Options */}
            <div className='space-y-3'>
              <div className='flex items-center justify-between'>
                <div className='h-3 bg-sd-muted rounded w-20'></div>
                <div className='h-5 w-10 bg-sd-muted rounded-full'></div>
              </div>
              <div className='flex items-center justify-between'>
                <div className='h-3 bg-sd-muted rounded w-24'></div>
                <div className='h-5 w-10 bg-sd-muted rounded-full'></div>
              </div>
            </div>
            
            {/* Additional Info */}
            <div className='pt-3 border-t border-sd-border'>
              <div className='h-3 bg-sd-muted rounded w-full'></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
